import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import { AdminAuthProvider } from 'contexts/AdminAuthContext';

export default function App() {
  return (
    <ThemeCustomization>
      <AdminAuthProvider>
        <RouterProvider router={router} />
      </AdminAuthProvider>
    </ThemeCustomization>
  );
}
